import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const ExportForm = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/ExportForm`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetColumnsByTableName = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetColumnsByTableName`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  var i = 1;
  if (result && result.data) 
  {
    result.data.map((item) =>
      listSelect.push({ id: item.Name, label: item.Name, col: i++ })
    );
  }
  return listSelect;
};

// Master
export const GetListEncryptMap = async (param) => {
  let url = `${API_URL.Loader}/api/Master/GetListEncryptMap`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.ENCRYPT_ID, label: item.ENCRYPT_NAME })
    );
  }
  
  return listSelect;
};

export const GetListEncrypt = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetListEncrypt`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.ENCRYPT_ID, label: item.ENCRYPT_NAME })
    );
  }
  
  return listSelect;
};

export const ConnectDatabase = async (param)=>{
  let url = `${API_URL.Query}/api/Decrypt/ConnectDB`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data; 
}

export const GetListTable = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetListTable`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const GetListSPI = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetListSPI`;
  let { result } = await common.to(axios.post(url, param));
  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.SPI_ID, label: item.SPI_NAME,message : item.SPI_MESSAGE })
    );
  }
  
  return listSelect;
};

export const GetMessageConsent = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetMessageConsent`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetMessageSPI = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetMessageSPI`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListHost = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetListHost`;
  let { result } = await common.to(axios.post(url, param));

  const listSelect = [];
  if (result && result.data) 
  {
    result.data.map(
      (item) => listSelect.push({ id: item.HOST_KEY, label: item.HOST_TITLE })
    );
  }
  
  return listSelect;
};